module.exports = __webpack_public_path__ + "static/media/g-1.032c1ca9.jpg";